import { render, staticRenderFns } from "./TS09.vue?vue&type=template&id=71edc986&scoped=true&"
import script from "./TS09.vue?vue&type=script&lang=js&"
export * from "./TS09.vue?vue&type=script&lang=js&"
import style0 from "./TS09.vue?vue&type=style&index=0&id=71edc986&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71edc986",
  null
  
)

export default component.exports